import { type App, type Ref, createApp, ref, watch } from "vue";
// eslint-disable-next-line @typescript-eslint/naming-convention
import DsModalVideo from "./ds-modal-video.vue";
import { DsModalVideoProps } from "./ds-modal-video-props";
import { Theme } from "../types/theme";

/**
 * Mount DS video component
 * @param videoCodeOrUrl - Youtube Video code or URL of the video on any platform
 * @param modelValue - Handles showing / hiding modal
 * @param isInStorybook - Use different assets path for storybook
 * @param theme - Theme - Design system theme
 * @param cssClass - Custom class for your css
 */
export function showModalVideo(props: DsModalVideoProps) {
    const modalRef: Ref<App> = ref(null);
    const isVisible = ref(true);

    modalRef.value = createApp(DsModalVideo, { ...props });

    const root = document.createElement("div");
    modalRef.value.mount(root);

    watch(isVisible, (newVal) => {
        if (!newVal) {
            modalRef.value.unmount();
        }
    });

    return {
        isVisible,
    };
}

export function useGlobalVideoModal() {
    document.addEventListener("click", (e: Event) => {
        const button = (e.target as HTMLElement).closest(".btn-video");
        if (!button) return;

        e.preventDefault();

        let theme = button.getAttribute("data-theme") as Theme;
        let url = button.getAttribute("data-video-codes");
        if (!theme) theme = "light";
        if (!url) url = button.getAttribute("href");

        showModalVideo({
            videoCodeOrUrl: url,
            modelValue: true,
            theme: theme,
        });
    });
}
